import { i18n } from "../../i18n";

/**
 * Function for translating keys using i18n.
 *
 * @param {string} tag - The translation key to look up.
 * @param {Object} [options] - Optional interpolation/pluralization options.
 * @returns {string} Translated string.
 */
export function translate(tag, options) {
  return i18n.t(tag, options);
}
